export const IN_ROOM_DINING = 'In-Room Dining';
export const MENU_CONFIGURATION = 'Menu Configuration';
export const IN_ROOM_DINING_MENU = 'Menu';
export const IN_ROOM_DINING_CATEGORY = 'Category';
export const IN_ROOM_DINING_COMBO = 'Combo';
export const IN_ROOM_DINING_ITEMS = 'Items';
export const IN_ROOM_DINING_CUSTOMISATIONS = 'Customisations';
export const IN_ROOM_DINING_ADDONS = 'Add-Ons';
export const IN_ROOM_DINING_TAGS = 'Tags';
export const IN_ROOM_DINING_ALLERGENS = 'Allergens';
export const IN_ROOM_DINING_DISCOUNT = 'Discount';
export const IN_ROOM_DINING_MENU_CREATE = 'menu_create';
export const IN_ROOM_DINING_MENU_EDIT_DRAWER = 'menu_create_drawer';
export const IN_ROOM_DINING_MENU_VIEW = 'menu_view';
export const IN_ROOM_DINING_MENU_INFO_VIEW = 'menu_info_view';
export const IN_ROOM_DINING_CATEGORY_CREATE = 'create_category';
export const IN_ROOM_DINING_CATEGORY_EDIT = 'category_edit';
export const IN_ROOM_DINING_CATEGORY_DAYS = [
  { id: 1, ischecked: false, name: 'Monday', from: null, to: null },
  { id: 2, ischecked: false, name: 'Tuesday', from: null, to: null },
  { id: 3, ischecked: false, name: 'Wednesday', from: null, to: null },
  { id: 4, ischecked: false, name: 'Thursday', from: null, to: null },
  { id: 5, ischecked: false, name: 'Friday', from: null, to: null },
  { id: 6, ischecked: false, name: 'Saturday', from: null, to: null },
  { id: 7, ischecked: false, name: 'Sunday', from: null, to: null },
];
export const IN_ROOM_DINING_MENUS_TAB = ['Details', 'Media'];
export const IN_ROOM_DINING_CATEGORY_TAB = ['Details', 'Hours', 'Media'];
export const IN_ROOM_DINING_CATEGORY_ALL_DAY = 'all day';
export const IN_ROOM_DINING_CATEGORY_EVERYDAY = 'everyday';
export const IN_ROOM_DINING_CATEGORY_TYPE = 'in_room_dining_category_type';
export const IN_ROOM_DINING_CATEGORY_VIEW = 'category_view';
export const IN_ROOM_DINING_CATEGORY_TAB_LIST = ['Details', 'Hours', 'Media'];

export const IN_ROOM_DINING_ITEMS_VIEW = 'items_view';
export const IN_ROOM_DINING_ITEMS_CREATE = 'items_create';
export const IN_ROOM_DINING_ITEMS_EDIT = 'items_edit';

export const IN_ROOM_DINING_ITEMS_ADDONS_GROUPED = 'GROUPED';
export const IN_ROOM_DINING_ITEMS_ADDONS_UNGROUPED = 'UNGROUPED';
export const IN_ROOM_DINING_ITEMS_ADDONS_INACTIVE = 'INACTIVE';

export const IN_ROOM_DINING_COMBO_ADDONS_GROUPED = 'GROUPED';
export const IN_ROOM_DINING_COMBO_ADDONS_UNGROUPED = 'UNGROUPED';
export const IN_ROOM_DINING_COMBO_ADDONS_INACTIVE = 'INACTIVE';

export const IN_ROOM_DINING_ITEMS_FILTER_TYPE_SUBMENU = [
  { id: '001', name: 'Food', selected: false },
  { id: '002', name: 'Beverages', selected: false },
];
export const IN_ROOM_DINING_ITEMS_FILTER_STATUS_SUBMENU = [
  { id: true, name: 'Active', selected: false },
  { id: false, name: 'Inactive', selected: false },
];
export const IN_ROOM_DINING_ITEMS_FILTER = [
  {
    title: 'All',
    field: 'all',
    subMenu: [],
  },
  {
    title: 'Type',
    field: 'type',
    subMenu: IN_ROOM_DINING_ITEMS_FILTER_TYPE_SUBMENU,
  },
  {
    title: 'Status',
    field: 'status',
    subMenu: IN_ROOM_DINING_ITEMS_FILTER_STATUS_SUBMENU,
  },
];

export const IN_ROOM_DINING_ITEMS_TAB_LIST = [
  'Details',
  'Add-ons',
  'Customisation',
  'Upsell',
  'Discounts',
  'Media',
];
export const IN_ROOM_DINING_CUSTOMISATIONS_CREATE = 'customisation_create';
export const IN_ROOM_DINING_CUSTOMISATIONS_VIEW = 'customisation_view';
export const IN_ROOM_DINING_CUSTOMISATIONS_EDIT = 'customisation_edit';
export const IN_ROOM_DINING_TAGS_CREATE = 'tags_create';
export const IN_ROOM_DINING_TAGS_EDIT = 'tags_edit';
export const IN_ROOM_DINING_TAGS_VIEW = 'tags_view';

export const IN_ROOM_DINING_ALLERGENS_CREATE = 'allergens_create';
export const IN_ROOM_DINING_ALLERGENS_EDIT = 'allergens_edit';
export const IN_ROOM_DINING_ALLERGENS_VIEW = 'allergens_view';

export const IN_ROOM_DINING_ADDONS_CREATE = 'addons_create';
export const IN_ROOM_DINING_ADDONS_EDIT = 'addons_edit';
export const IN_ROOM_DINING_ADDONS_VIEW = 'addons_view';

export const IN_ROOM_DINING_DISCOUNTS_CREATE = 'discount_create';
export const IN_ROOM_DINING_DISCOUNTS_EDIT = 'discount_edit';
export const IN_ROOM_DINING_DISCOUNTS_VIEW = 'discount_view';
export const IN_ROOM_DINING_DISCOUNTS_TABS = ['Details', 'Schedule'];

export const IN_ROOM_DINING_COMBO_CREATE = 'combo_create';
export const IN_ROOM_DINING_COMBO_EDIT = 'combo_edit';
export const IN_ROOM_DINING_COMBO_VIEW = 'combo_view';
export const IN_ROOM_DINING_COMBO_TAB = ['Details', 'Add-ons', 'Upsell', 'Media'];
export const IN_ROOM_DINING_COMBO_TYPE = 'in_room_dining_combo_type';

export const IN_ROOM_DINING_MENU_CREATE_TYPE = 'menu_create_type';
export const IN_ROOM_DINING_MENU_POS_LIST = [
  { id: 1, name: 'Food', isSynced: true, isSelected: false },
  { id: 2, name: 'Beverages', isSynced: true, isSelected: false },
  { id: 3, name: 'Alcoholic Beverages', isSynced: false, isSelected: false },
];
export const IN_ROOM_DINING_MENU_ITEMS = 'Items';
export const IN_ROOM_DINING_MENU_COMBO = 'Combo';
export const IN_ROOM_DINING_MENU_CATEGORIES = 'Categories';
export const IN_ROOM_DINING_MENU_CREATE_DRAWER = 'create_drawer';
export const IN_ROOM_DINING_MENU_TAB = ['Details', 'Hours', 'Media'];
export const IN_ROOM_DINING_MENU_TYPE = 'menu_type';

export const ITEMS_TYPE = [
  { id: 'FOOD', name: 'Food' },
  { id: 'BEVERAGE', name: 'Beverage' },
];

export const IN_ROOM_DINING_TYPE = 'in_room_dining_type';

export const IN_ROOM_DINING_ADDON_ALREADY_OCCUPIED_ERROR = 'error deleting ird addon';
export const IN_ROOM_DINING_SELECTED_ITEM_ALREADY_OCCUPIED_ERROR = 'already occupied with menu';

export const IRD_MENU_UPLOAD = 'Uploaded Menu';
export const IRD_MENU_IMPORT = 'Imported Menu';
export const IRD_MENU_BUILD = 'Menu Builder';
